import { baseComponentSchema } from 'ctm-vertical-base';

import components from './components.json';
import results from './results.json';
import sidebar from './sidebar.json';
import resultsCallOptions from './results_call_options.json';
import pleaseWait from './please_wait.json';
import insurerHandover from './insurer_handover.json';
import resultsFeatureView from './results_feature_view.json';
import noResultsOverlay from './no_results.json';
import resultsModals from './results_modals.json';
import resultsMoreInfo from './results_more_info.json';
import footer from './footer.json';
import errors from './errors.json';
import verify from './verify_page.json';
import confirmation from './confirmation.json';
import quotesExpired from './quotes_expired_page.json'

export default {
    ...baseComponentSchema,
    ...components,
    ...pleaseWait,
    ...insurerHandover,
    ...results,
    ...sidebar,
    ...resultsFeatureView,
    ...resultsCallOptions,
    ...resultsModals,
    ...noResultsOverlay,
    ...resultsMoreInfo,
    ...footer,
    ...errors,
    ...verify,
    ...confirmation,
    ...quotesExpired
};
